import { render, staticRenderFns } from "./OsPaginationInventario.vue?vue&type=template&id=466aa5c1&"
import script from "./OsPaginationInventario.vue?vue&type=script&lang=js&"
export * from "./OsPaginationInventario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports